import {
    Button, Col, DatePicker, Divider, Drawer, Form, FormInstance, Input, InputNumber, message, Modal
    , Row, Select, Space, Switch, Table, Typography, theme
} from "antd";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import CustomerEdit from "../../03.masterdata/customer/CustomerEdit";
import SalesEdit from "../../03.masterdata/sales/SalesEdit";
import { QuestionCircleOutlined, CaretDownOutlined, ReloadOutlined, LineOutlined, SearchOutlined } from '@ant-design/icons';
import EAttachment from "../../../components/eattachment/EAtachment";

const InquiryOrderEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const refUrl = useRef<any>(null);
    const refLicenseUrl = useRef<any>(null);
    const refOrderUrl = useRef<any>(null);

    const { ...rest } = props;

    const [inquiryDate, setInquiryDate] = useState<any>(null);
    const [expiredDate, setExpiredDate] = useState<any>(null);

    const [customer, setCustomer] = useState<any>(null);
    const [customerData, setCustomerData] = useState<any>([]);

    const [isOpen, setIsOpen] = useState(false);
    const [editRecord, setEditRecord] = useState<any>({});

    const [sales, setSales] = useState<any>(null);
    const [salesData, setSalesData] = useState<any>([]);

    const [isOpenSales, setIsOpenSales] = useState(false);
    const [editRecordSales, setEditRecordSales] = useState<any>({});

    useEffect(() => {
        if (rest.isOpen) {
            loadCustomer();
            loadSales();
            switch (rest.viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    getInquiryOrder();
                    break;
                case 2:
                    getInquiryOrder();
                    break;
            }
        }
    }, [rest.isOpen])

    const loadCustomer = () => {
        Server.Post(URL.Customer.GetCustomerOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setCustomerData(response.data);
            }
        })
    }

    const loadSales = () => {
        Server.Post(URL.Sales.GetSalesOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setSalesData(response.data);
            }
        })
    }

    const setData = (record: any) => {
        if (record) {
            formRef.current?.setFieldsValue({
                ...record,
                customer: { value: record.customerID, label: record.customerName },
                inquiryDate: record.inquiryDate,
                expiredDate: record.expiredDate,
                insureType: { value: record.insureTypeEnum, label: record.insureType },
                city: record.cityFullName,
                sales: { value: record.salesID, label: record.salesName },
                remark: record.remark,
            });
            setInquiryDate(moment(record.inquiryDate));
            setExpiredDate(moment(record.expiredDate));
            if (record.customerID == "00000000-0000-0000-0000-000000000000") {
                var filters = customerData.filter((item: any) => item.label == record.customerName);
                if (filters && filters.length > 0) {
                    setCustomer(filters[0]);
                } else {
                    setCustomerData([
                        ...customerData,
                        {
                            value: record.customerID,
                            label: record.customerName,
                        }
                    ]);
                }
            } else {
                setCustomer({ value: record.customerID, label: record.customerName });
            }
            setSales({ value: record.salesID, label: record.salesName });

            if (record.isFinished && record.url) {
                refUrl.current?.setData(JSON.parse(record.url));
            } else {
                refUrl.current?.setData(null);
            }

            if (record.isUpLicense && record.licenseUrl) {
                refLicenseUrl.current?.setData(JSON.parse(record.licenseUrl));
            } else {
                refLicenseUrl.current?.setData(null);
            }

            if (record.isUpOrder && record.orderUrl) {
                refOrderUrl.current?.setData(JSON.parse(record.orderUrl));
            } else {
                refOrderUrl.current?.setData(null);
            }
        }
        else {
            formRef.current?.resetFields();
            setInquiryDate(moment());
            setExpiredDate(moment());
            setCustomer(null);
            refUrl.current?.setData(null);
            refLicenseUrl.current?.setData(null);
            refOrderUrl.current?.setData(null);
        }
    }

    const getInquiryOrder = () => {
        if (rest.inquiryOrderID) {
            var params = {
                inquiryOrderID: rest.inquiryOrderID
            };
            Server.Post(URL.InquiryOrder.GetInquiryOrder, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                    if (response.customerID == "00000000-0000-0000-0000-000000000000") {
                        var filters = customerData.filter((item: any) => item.label == response.customerName);
                        if (filters && filters.length > 0) {
                            setCustomer(filters[0]);
                        } else {
                            setCustomerData([
                                ...customerData,
                                {
                                    value: response.customerID,
                                    label: response.customerName,
                                }
                            ]);
                        }
                    }
                }
            })
        }
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var url = refUrl.current?.getData();
            var urlLicense = refLicenseUrl.current?.getData();
            var urlOrder = refOrderUrl.current?.getData();
            var params = {
                ...values,
                inquiryOrderID: props.inquiryOrderID,
                inquiryOrderNO: props.inquiryOrderNO ?? '',
                inquiryDate: moment(inquiryDate),
                inquiryMonth: moment(inquiryDate).format('M'),
                expiredDate: moment(expiredDate),
                expiredMonth: moment(expiredDate).format('M'),
                insureTypeEnum: values.insureType?.value,
                insureType: values.insureType?.label,
                customerID: customer.value,
                customerName: customer.label,
                cityName: values.city ?? '',
                cityFullName: values.city ?? '',
                salesID: sales.value,
                salesName: sales.label,
                remark: values.remark ?? '',
                licenseUrl: urlLicense,
                orderUrl: urlOrder,
            };

            Server.Post(URL.InquiryOrder.SaveInquiryOrder, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        })).catch((info: any) => {
            console.log(info);
        });
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Drawer title={(rest.viewMode == 0 ? '新增' : '编辑') + "询价单"} width={1000} visible={rest.isOpen} onClose={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: 0, margin: 10 }}
        footer={
            <Space style={{ float: 'right' }}>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            style={{ margin: '8px' }}
            labelCol={{ flex: '105px' }}
            wrapperCol={{ span: 24 }}
            labelWrap>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />基本信息</div>
            <div style={{ marginLeft: '10px' }} >
                <Form.Item hidden label={'询价单ID'} name={'inquiryOrderID'} initialValue={null}>
                    <Input readOnly={rest.viewMode == 2} />
                </Form.Item>
                <Row>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'投保客户'} name={'customer'}
                            initialValue={customer} rules={[{ required: true, message: '请选择投保客户' }]}>
                            <Space.Compact style={{ width: '100%' }}>
                                <Select defaultValue={customer?.value}
                                    value={customer?.value}
                                    labelInValue
                                    placeholder={'选择投保客户'}
                                    onSelect={(e) => {
                                        setCustomer(e);
                                        formRef.current?.setFieldValue('customer', e)
                                    }}
                                    style={{ width: '100%' }}
                                    options={customerData}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption} />
                                <Button style={{ width: '50px', marginLeft: '5px' }}
                                    onClick={() => {
                                        setEditRecord({
                                            viewMode: 0,
                                            customerID: null
                                        });
                                        setIsOpen(true)
                                    }}><PlusOutlined /></Button>
                            </Space.Compact>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'询价日期'} name={'inquiryDate'}
                            initialValue={moment()} rules={[{ required: true, message: '请选择询价日期' }]}>
                            <Space.Compact style={{ width: '100%' }}>
                                <DatePicker style={{ width: '100%' }}
                                    onChange={(value) => {
                                        setInquiryDate(value);
                                    }}
                                    defaultValue={moment()}
                                    format="YYYY-MM-DD"
                                    value={inquiryDate} />
                                <span style={{ width: '50px', margin: '5px' }}>
                                    {(inquiryDate ? moment(inquiryDate).format('M') : moment().format('M')) + '月'}
                                </span>
                            </Space.Compact>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label='保险险种' name={'insureType'}
                            initialValue={{ value: '0', label: '货运险' }} rules={[{ required: true, message: '请选择保险险种' }]}>
                            <Select
                                labelInValue
                                style={{ width: '100%' }}
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={[
                                    { value: '0', label: '货运险' },
                                    { value: '1', label: '物流责任险' },
                                    { value: '2', label: '雇主责任险' },
                                    { value: '3', label: '团体意外险' },
                                    { value: '4', label: '仓储险' },
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'到期日期'} name={'expiredDate'}
                            initialValue={moment()} rules={[{ required: true, message: '请选择保险到期日期' }]}>
                            <Space.Compact style={{ width: '100%' }}>
                                <DatePicker style={{ width: '100%' }}
                                    onChange={(value) => {
                                        setExpiredDate(value);
                                    }}
                                    defaultValue={moment()}
                                    format="YYYY-MM-DD"
                                    value={expiredDate} />
                                <span style={{ width: '50px', margin: '5px' }}>
                                    {(expiredDate ? moment(expiredDate).format('M') : moment().format('M')) + '月'}
                                </span>
                            </Space.Compact>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'营业额'} name={'salesAmount'}
                            initialValue={0} rules={[{ required: true, message: '请输入营业额' }]}>
                            <InputNumber style={{ width: '100%' }} placeholder={'输入营业额'} addonAfter={'万元'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'单次限额'} name={'singleLimitAmount'}
                            initialValue={0} rules={[{ required: true, message: '请输入单次限额' }]}>
                            <InputNumber style={{ width: '100%' }} placeholder={'输入单次限额'} addonAfter={'万元'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'保费'} name={'orderAmount'}
                            initialValue={0} rules={[{ required: true, message: '请输入保费' }]}>
                            <InputNumber style={{ width: '100%' }} placeholder={'输入保费'} addonAfter={'万元'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'投保公司'} name={'companyName'}
                            initialValue={''} rules={[{ required: true, message: '请输入投保公司' }]}>
                            <Input placeholder={'输入投保公司'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'所在城市'} name={'city'}
                            initialValue={''} rules={[{ required: true, message: '请输入所在城市' }]}>
                            <Input placeholder={'输入所在城市'} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item
                            style={{ marginBottom: '5px' }} label='业务员' name={'sales'}
                            initialValue={sales}
                            rules={[{ required: true, message: '请选择业务员' }]}>
                            <Space.Compact style={{ width: '100%' }}>
                                <Select defaultValue={sales?.value}
                                    value={sales?.value}
                                    labelInValue
                                    placeholder={'选择业务员'}
                                    onSelect={(e) => {
                                        setSales(e);
                                        formRef.current?.setFieldValue('sales', e)
                                    }}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}
                                    style={{ width: 'calc(100% - 55px)' }}
                                    options={salesData} />
                                <Button style={{ width: '50px', marginLeft: '5px' }}
                                    onClick={() => {
                                        setEditRecordSales({
                                            viewMode: 0,
                                            salesID: null
                                        });
                                        setIsOpenSales(true)
                                    }}><PlusOutlined /></Button>
                            </Space.Compact>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            style={{ marginBottom: '5px' }}
                            label={'备注'} name={'remark'} initialValue={''} >
                            <Input style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'是否锁定'} name={'isLock'} initialValue={false} valuePropName={'checked'}>
                            <Switch disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />问卷调查</div>
            <div style={{ marginLeft: '10px' }} >
                <Row>
                    <Col span={24}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'是否完成'} name={'isFinished'} initialValue={false} valuePropName={'checked'}>
                            <Switch disabled />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <EAttachment name="url" viewMode={0} formRef={formRef} ref={refUrl} />
                    </Col>
                </Row>
            </div>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />营业执照</div>
            <div style={{ marginLeft: '10px' }} >
                <Row>
                    <Col span={24}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'是否上传'} name={'isUpLicense'} initialValue={false} valuePropName={'checked'}>
                            <Switch disabled />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <EAttachment name="licenseUrl" viewMode={0} formRef={formRef} ref={refLicenseUrl} onChanged={(value: any) => {
                            formRef.current?.setFieldValue('isUpLicense', value ? true : false);
                            if (value) {
                                formRef.current?.setFieldValue('isLock', true);
                            } else {
                                // if (refLicenseUrl.current.getData()&&)
                            }
                        }} />
                    </Col>
                </Row>
            </div>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />历史保单</div>
            <div style={{ marginLeft: '10px' }} >
                <Row>
                    <Col span={24}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'是否上传'} name={'isUpOrder'} initialValue={false} valuePropName={'checked'}>
                            <Switch disabled checked />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <EAttachment name="orderUrl" viewMode={0} formRef={formRef} ref={refOrderUrl} onChanged={(value: any) => {
                            formRef.current?.setFieldValue('isUpOrder', value ? true : false);
                            if (value) {
                                formRef.current?.setFieldValue('isLock', true);
                            }
                        }} />
                    </Col>
                </Row>
            </div>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />黑名单</div>
            <div style={{ marginLeft: '10px' }} >
                <Row>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'是否黑名单'} name={'isBlack'} initialValue={false} valuePropName={'checked'}>
                            <Switch disabled checked />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item style={{ marginBottom: '5px' }} label={'黑名单等级'} name={'blackLevel'} initialValue={null}>
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        </Form>
        <CustomerEdit isOpen={isOpen} setIsOpen={() => setIsOpen(false)} loadData={loadCustomer} {...editRecord} />
        <SalesEdit isOpen={isOpenSales} setIsOpen={() => setIsOpenSales(false)} loadData={loadSales} {...editRecordSales} />
    </Drawer >
};
export default InquiryOrderEdit;
